module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAABBCAMAAAC6njdfAAAAVFBMVEUAAABnZ2dnZ2dnZ2dnZ2dsbGxnZ2dqampmZmZnZ2dnZ2dmZmZnZ2dmZmZmZmZmZmZmZmZmZmZnZ2doaGhmZmZnZ2dqampmZmZmZmZmZmZubm5mZmYmoxdrAAAAG3RSTlMApvZKUhTTGNeclefB+cu4fnFpOzMlBu6sVRL7qHVGAAAA0ElEQVRIx+3LSQ7CMAxAURdoCyQMHRly/3tS1MVfWGoSr7rIX1iy5Sdbfc7NSYy1txBurREfw9LRiE8FF1xwwQXvFA9390zHT9cMQm75uqbiy3J1rHUIaIW1Xao5ePQWxnqh9ozWWNumli0Njlq0xnGL1jhu0RrHLVrjuEVrHLdojeMWrTE2TYO1jWswNlWDsakajM3QK86y6BVjs/RjHdhkTViDxho01qCxORqbX/3+2+ortsa+H6W0lyZ/MOYnuQdzXl527KSy44vMXWWsm3+cCkajrDKXxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/download.png
// module id = S+TL
// module chunks = 1